<template>
  <div class="home caseStudyPage">

    <indiSplash
      :acf="acf"
      :id="wpPageId"
    />

    <main class="caseStudyContent">

      <div class="container">

        <!-- Back link -->
        <div class="backLinkWrap">
          <a
            href="/#/case-studies"
            class="backLink"
          >
            <span class="backArrow">←</span>
            Back to case studies
          </a>
        </div>

        <!-- Article Header -->
        <header class="articleHeader">

          <div class="articleEyebrow">
            OCS SPORT
            <span></span>
            CASE STUDY
          </div>

          <h1 class="postTitle">
            {{ postInfo.title.rendered }}
          </h1>

          <div class="titleLine"></div>

        </header>


        <!-- Article -->
        <article
          class="contentRendered"
          v-html="postInfo.content.rendered"
        ></article>


        <!-- Bottom CTA -->
        <div class="caseStudyBottom">

          <div class="bottomLine"></div>

          <h3>
            Discover more from OCS Sport
          </h3>

          <p>
            Explore how OCS Sport helps professional golf tours
            manage tournaments, scoring, websites and mobile experiences.
          </p>

          <a
            href="/#/case-studies"
            class="caseStudyButton"
          >
            View all case studies
            <span>→</span>
          </a>

        </div>

      </div>

    </main>

    <Footer />

  </div>
</template>

<script>
import axios from "axios";
import Footer from "@/components/footer.vue";
import indiSplash from "@/components/indiSplash.vue";
export default {
  name: "Post Case Studies",
  components: { Footer, indiSplash},
  data: function() {
    return {
      acf: [],
      postInfo: []
    };
  },
  mounted() {
    axios //add API Call
      .get(
        process.env.VUE_APP_API_URL + "wp-json/wp/v2/posts?slug=" + this.$route.params.id 
      ) // Page number changed on each page based on JSON page id you are calling
      .then((response) => (
        this.postInfo = response.data[0]
      )); //API data wanted pulled out
  },
};
</script>

<style scoped>

/* =========================================
   PAGE
========================================= */

.caseStudyPage {
  background: #ffffff;
}

.caseStudyContent {
  padding: 55px 0 110px;
}


/* =========================================
   BACK LINK
========================================= */

.backLinkWrap {
  max-width: 1000px;
  margin: 0 auto 55px;
}

.backLink {
  display: inline-flex;
  align-items: center;
  gap: 10px;

  color: #68717a !important;

  font-size: 13px;
  font-weight: 700;

  text-transform: uppercase;
  letter-spacing: 1px;

  text-decoration: none !important;

  transition: color 0.25s ease;
}

.backLink:hover {
  color: #00aeef !important;
}

.backArrow {
  font-size: 19px;
  line-height: 1;

  transition: transform 0.25s ease;
}

.backLink:hover .backArrow {
  transform: translateX(-4px);
}


/* =========================================
   ARTICLE HEADER
========================================= */

.articleHeader {
  max-width: 1000px;
  margin: 0 auto;

  padding-bottom: 55px;
}

.articleEyebrow {
  display: flex;
  align-items: center;
  gap: 10px;

  margin-bottom: 22px;

  color: #00aeef;

  font-size: 11px;
  font-weight: 700;

  letter-spacing: 1.8px;
}

.articleEyebrow span {
  display: block;

  width: 4px;
  height: 4px;

  border-radius: 50%;

  background: #c8cdd2;
}


.postTitle {
  margin: 0;

  max-width: 950px;

  color: #111820;

  font-size: 52px;
  line-height: 1.12;

  font-weight: 700;

  letter-spacing: -1px;
}

.titleLine {
  width: 60px;
  height: 4px;

  margin-top: 32px;

  background: #00aeef;
}


/* =========================================
   ARTICLE CONTENT
========================================= */

.contentRendered {
  max-width: 900px;

  margin: 0 auto;

  color: #40484f;

  font-size: 17px;
  line-height: 1.85;

  font-weight: 400;
}


/* =========================================
   PARAGRAPHS
========================================= */

::v-deep .contentRendered p {
  margin: 0 0 28px;
}


/* =========================================
   HEADINGS
========================================= */

::v-deep .contentRendered h1,
::v-deep .contentRendered h2,
::v-deep .contentRendered h3,
::v-deep .contentRendered h4 {
  color: #111820;

  font-weight: 700;

  line-height: 1.25;
}

::v-deep .contentRendered h1 {
  font-size: 38px;

  margin-top: 65px;
  margin-bottom: 25px;
}

::v-deep .contentRendered h2 {
  position: relative;

  font-size: 32px;

  margin-top: 65px;
  margin-bottom: 25px;
}

::v-deep .contentRendered h2::before {
  content: "";

  display: block;

  width: 35px;
  height: 3px;

  margin-bottom: 18px;

  background: #00aeef;
}

::v-deep .contentRendered h3 {
  font-size: 25px;

  margin-top: 50px;
  margin-bottom: 20px;
}

::v-deep .contentRendered h4 {
  font-size: 20px;

  margin-top: 40px;
  margin-bottom: 15px;
}


/* =========================================
   LINKS
========================================= */

::v-deep .contentRendered a {
  color: #00aeef;

  font-weight: 600;

  text-decoration: none;

  border-bottom: 1px solid rgba(0, 174, 239, 0.35);

  transition:
    border-color 0.25s ease,
    color 0.25s ease;
}

::v-deep .contentRendered a:hover {
  color: #008fc5;

  border-color: #008fc5;
}


/* =========================================
   LISTS
========================================= */

::v-deep .contentRendered ul,
::v-deep .contentRendered ol {
  margin: 0 0 30px;

  padding-left: 25px;
}

::v-deep .contentRendered li {
  margin-bottom: 10px;

  padding-left: 5px;
}


/* =========================================
   BLOCKQUOTES
========================================= */

::v-deep .contentRendered blockquote {
  position: relative;

  margin: 50px 0;

  padding: 30px 35px;

  border-left: 4px solid #00aeef;

  background: #f4f6f8;

  color: #111820;

  font-size: 21px;
  line-height: 1.6;

  font-weight: 600;
}


/* =========================================
   IMAGES
========================================= */

::v-deep .contentRendered img {
  display: block;

  width: 100%;
  height: auto;

  margin: 45px 0;

  border-radius: 2px;
}


/* =========================================
   IMAGE CAPTIONS
========================================= */

::v-deep .contentRendered .wp-caption {
  width: 100% !important;

  margin: 45px 0;
}

::v-deep .contentRendered .wp-caption img {
  margin: 0 0 10px;
}

::v-deep .contentRendered .wp-caption-text {
  color: #8a9299;

  font-size: 13px;
  line-height: 1.5;

  font-style: italic;
}


/* =========================================
   TABLES
========================================= */

::v-deep .contentRendered table {
  width: 100%;

  margin: 40px 0;

  border-collapse: collapse;

  font-size: 15px;
}

::v-deep .contentRendered th {
  padding: 15px;

  background: #111820;

  color: #ffffff;

  text-align: left;

  font-weight: 700;
}

::v-deep .contentRendered td {
  padding: 15px;

  border-bottom: 1px solid #e4e7e9;
}


/* =========================================
   HORIZONTAL RULE
========================================= */

::v-deep .contentRendered hr {
  margin: 55px 0;

  border: 0;

  border-top: 1px solid #e4e7e9;
}


/* =========================================
   STRONG TEXT
========================================= */

::v-deep .contentRendered strong {
  color: #111820;

  font-weight: 700;
}


/* =========================================
   BOTTOM CTA
========================================= */

.caseStudyBottom {
  max-width: 900px;

  margin: 90px auto 0;

  padding: 55px 50px;

  text-align: center;

  background: #f4f6f8;
}

.bottomLine {
  width: 45px;
  height: 4px;

  margin: 0 auto 25px;

  background: #00aeef;
}

.caseStudyBottom h3 {
  margin: 0 0 15px;

  color: #111820;

  font-size: 28px;
  font-weight: 700;
}

.caseStudyBottom p {
  max-width: 600px;

  margin: 0 auto 30px;

  color: #68717a;

  font-size: 16px;
  line-height: 1.7;
}


/* =========================================
   CTA BUTTON
========================================= */

.caseStudyButton {
  display: inline-flex;

  align-items: center;

  gap: 12px;

  padding: 15px 24px;

  background: #00aeef;

  color: #ffffff !important;

  font-size: 12px;
  font-weight: 700;

  text-transform: uppercase;

  letter-spacing: 1px;

  text-decoration: none !important;

  border: none !important;

  transition:
    background 0.25s ease,
    transform 0.25s ease;
}

.caseStudyButton:hover {
  background: #009bd6;

  transform: translateY(-2px);
}

.caseStudyButton span {
  font-size: 18px;
  line-height: 1;

  transition: transform 0.25s ease;
}

.caseStudyButton:hover span {
  transform: translateX(4px);
}


/* =========================================
   SPLASH
========================================= */

::v-deep .splash {
  height: auto !important;
}


/* =========================================
   RESPONSIVE
========================================= */

@media only screen and (max-width: 992px) {

  .caseStudyContent {
    padding: 45px 0 80px;
  }

  .articleHeader,
  .contentRendered,
  .backLinkWrap {
    max-width: 90%;
  }

  .postTitle {
    font-size: 44px;
  }

}


/* =========================================
   TABLET
========================================= */

@media only screen and (max-width: 768px) {

  .caseStudyContent {
    padding: 35px 0 65px;
  }

  .backLinkWrap {
    margin-bottom: 40px;
  }

  .articleHeader {
    padding-bottom: 40px;
  }

  .postTitle {
    font-size: 36px;

    letter-spacing: -0.5px;
  }

  .contentRendered {
    font-size: 16px;

    line-height: 1.75;
  }

  ::v-deep .contentRendered h2 {
    font-size: 28px;

    margin-top: 50px;
  }

  ::v-deep .contentRendered h3 {
    font-size: 23px;
  }

  ::v-deep .contentRendered blockquote {
    margin: 40px 0;

    padding: 25px;

    font-size: 19px;
  }

  .caseStudyBottom {
    margin-top: 65px;

    padding: 45px 30px;
  }

}


/* =========================================
   MOBILE
========================================= */

@media only screen and (max-width: 480px) {

  .caseStudyContent {
    padding: 30px 0 50px;
  }

  .articleHeader,
  .contentRendered,
  .backLinkWrap {
    max-width: calc(100% - 40px);
  }

  .backLinkWrap {
    margin-bottom: 32px;
  }

  .articleEyebrow {
    font-size: 10px;
  }

  .postTitle {
    font-size: 31px;

    line-height: 1.15;
  }

  .titleLine {
    margin-top: 25px;
  }

  .contentRendered {
    font-size: 15px;

    line-height: 1.7;
  }

  ::v-deep .contentRendered h1 {
    font-size: 30px;

    margin-top: 50px;
  }

  ::v-deep .contentRendered h2 {
    font-size: 25px;

    margin-top: 45px;
  }

  ::v-deep .contentRendered h3 {
    font-size: 21px;

    margin-top: 40px;
  }

  ::v-deep .contentRendered img {
    margin: 35px 0;
  }

  ::v-deep .contentRendered blockquote {
    padding: 22px;

    font-size: 17px;
  }

  .caseStudyBottom {
    max-width: calc(100% - 40px);

    margin-top: 50px;

    padding: 35px 20px;
  }

  .caseStudyBottom h3 {
    font-size: 24px;
  }

}

</style>
